import { useRouter } from "next/router";
import { LOCALES, localizePath, stripLocaleFromPath } from "@/lib/i18n-config";
import { useI18n } from "./I18nContext";

// A native <select>, styled to match the white rounded pill the Google
// Translate widget used to render in the blue header bar. Using a real select
// rather than a custom dropdown means the OS supplies the chevron, the keyboard
// behaviour and the mobile picker for free — and there is nothing to close on
// outside click.

export default function LanguageSwitcher() {
  const { meta } = useI18n();
  const router = useRouter();
  const bare = stripLocaleFromPath(router.asPath || "/");

  // Header only renders this on pages that have translated counterparts, so
  // the current path always has a valid equivalent in every locale.
  const targetBase = bare;

  return (
    <select
      name="language"
      className="language-select"
      aria-label="Select language"
      value={meta.code}
      onChange={(e) => {
        router.push(localizePath(targetBase, e.target.value, true));
      }}
    >
      {LOCALES.map((l) => (
        <option key={l.code} value={l.code}>
          {l.label}
        </option>
      ))}
    </select>
  );
}
